import { User } from "@/types/user";
import { Skeleton } from "@/components/ui/skeleton";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import CommonImg from "@/components/Common/Img";
import DeleteIcon from "@/assets/images/delete-pink.svg";
import { Plus } from "lucide-react";
import CommonAvatar from "@/components/Common/Avatar";
import { useRemoveProjectGroupsTasksAssignees } from "@/libs/react-query/hooks/useTaskQuery";
import { useParams } from "react-router-dom";
import InviteUserDialog from "./InviteUserDialog";

type Props = {
  assignees: User[];
  isLoading?: boolean;
};

export default function TaskAssignees({ assignees, isLoading = false }: Props) {
  const { task_id = "", group_id = "" } = useParams();

  const { mutate: removeAssignees } = useRemoveProjectGroupsTasksAssignees({
    group_id,
    task_id,
  });

  const handleRemoveAssignee = (user_id: string) => () => {
    removeAssignees({ assignees: [{ user_id }] });
  };

  if (isLoading) return <Skeleton className="w-full h-[360px]" />;

  return (
    <div className="flex flex-col w-full h-[360px] gap-3 ">
      <div className="flex flex-col gap-3 overflow-auto">
        {assignees.map((user) => (
          <div
            className="flex items-center gap-2"
            key={`users-${user.user_id}`}
          >
            <CommonAvatar
              img_url={user.img_url}
              name={user.user_name}
              textClassName="font-semibold"
            />
            <div className="w-full flex items-center justify-between">
              <span className="text-xs text-gray-C font-semibold">
                {user.group_name}
              </span>
              <CommonImg
                src={DeleteIcon}
                alt="delete"
                className="cursor-pointer"
                onClick={handleRemoveAssignee(user.user_id)}
              />
            </div>
          </div>
        ))}
      </div>
      <InviteUserDialog />
    </div>
  );
}
